module.exports = __webpack_public_path__ + "media/nf_legis.29b4b25c.mp4";